import type { ValuesOf } from '@shared/types';

export const PurchaseRequestState = {
  Default: 'default',
  SendRequest: 'sendRequest',
  Success: 'success',
} as const;

export type PurchaseRequestState = ValuesOf<typeof PurchaseRequestState>;
